import GuestListActions from '../../actions/GuestListActions';
import UserActions from '../../actions/UserActions';
import PosActions from '../../actions/PosActions';

import UserStore from '../../stores/UserStore';
import PosStore from '../../stores/PosStore';
import GuestListStore from '../../stores/GuestListStore';
import ConfigStore from '../../stores/ConfigStore';

import Guest from './Guest.react';
import GLStatus from './GLStatus.react';
import GLRoom from './GLRoom.react';

var timer;

class GuestList extends React.Component {

    constructor(props) {
        super(props);
        this._mounted = false;
        this.state = {
            selected : false,

            filter   : '',

            sortBy   : PosStore.getState().sortGLBy,
            sortType : PosStore.getState().sortGLType,

            uuid     : uuid(),

            intervalId : 0,

            delay: 10000,
            maxDelay: 300000,

            showGuestAssignedToRegister : GuestListStore.getState().showGuestAssignedToRegister,

            pusherConnected: false
        };

        this.onPosStoreChange = this.onPosStoreChange.bind(this);
        this.onGuestListStoreChange = this.onGuestListStoreChange.bind(this);
        this.onUserStoreChange = this.onUserStoreChange.bind(this);
        this.exponentialBackoff = this.exponentialBackoff.bind(this);
        this.setBackoff = this.setBackoff.bind(this);
        this.sort = this.sort.bind(this);
        this.timer = this.timer.bind(this);
        
    }


    setBackoff(method) {
        this.exponentialBackoff(method);
    }

    exponentialBackoff(toRun) {
        let self = this;
        toRun(false, false).then(res => {
            //kill timer if component is no longer mounted
            if(!self._mounted || (this.props.selectedLocation && this.props.selectedLocation.UseSmartCheckin)) {
                return;
            }
            if (res.Result) {
                setTimeout(() => {
                    self.exponentialBackoff(toRun, this.state.delay, this.state.delay, this.state.maxDelay);
                }, this.state.delay);
            } else {
                setTimeout(() => {
                    self.exponentialBackoff(toRun, _.min([this.state.delay * 2, this.state.maxDelay]), this.state.delay, this.state.maxDelay);
                }, this.state.delay);
            }
        }); 
    }

    componentDidMount() {
        PosStore.addChangeListener(this.onPosStoreChange);
        GuestListStore.addChangeListener(this.onGuestListStoreChange);
        UserStore.addChangeListener(this.onUserStoreChange);

        var self = this;
        this._mounted = true;
        if (!ConfigStore.isDev()) {
            var intervalId = setInterval(this.timer, 1000);
            this.setBackoff(GuestListActions.loadGuestList);

            this.setState({
                intervalId : intervalId,
            });
       }
    }

    componentWillUnmount() {
        PosStore.removeChangeListener(this.onPosStoreChange);
        GuestListStore.removeChangeListener(this.onGuestListStoreChange);
        UserStore.removeChangeListener(this.onUserStoreChange);

        clearInterval(this.state.intervalId);
        this._mounted = false;
    }

    onPosStoreChange() {
        this.setState({
            sortBy   : PosStore.getState().sortGLBy,
            sortType : PosStore.getState().sortGLType,
        });
    }

    onGuestListStoreChange() {
        this.setState({
            showGuestAssignedToRegister : GuestListStore.getState().showGuestAssignedToRegister,
            pusherConnected: GuestListStore.getState().pusherConnected
        })
    }

    onUserStoreChange() {
        
        if(UserStore.getState() && UserStore.getState().selectedLocation){
            const millis = UserStore.getState().selectedLocation.GuestListRefreshRate * 1000;
            this.setState({
                delay: millis
            })
            if(this.state.maxDelay <= (UserStore.getState().selectedLocation.GuestListRefreshRate * 1000) ){
                this.setState({maxDelay: ((UserStore.getState().selectedLocation.GuestListRefreshRate + 60 ) * 1000)})
            }  
        }
    }

    timer() {
        this.setState({ uuid : uuid() });
    }

    sort(by) {
        var sortType = 'asc';

        if (by === 'FullName') {
            if (this.state.sortBy !== 'FullName')
                sortType = 'asc';
            else
                sortType = this.state.sortType === 'asc' ? 'desc' : 'asc';
        } else if (by === 'CheckInDate') {
            if (this.state.sortBy !== 'CheckInDate')
                sortType = 'asc'
            else
                sortType = this.state.sortType === 'asc' ? 'desc' : 'asc';
        }

        PosActions.setGuestListSorting({ sortBy : by, sortType : sortType });
    }

    render() {
        var selectedLocation = this.props.selectedLocation;
        if(selectedLocation && ((selectedLocation.GuestListRefreshRate * 1000) > this.state.delay)){
            this.setState({delay: (selectedLocation.GuestListRefreshRate * 1000)});
            if(this.state.maxDelay <= (selectedLocation.GuestListRefreshRate * 1000) ){
                this.setState({maxDelay: ((selectedLocation.GuestListRefreshRate + 60 ) * 1000)})
            }
        }
        
        var page      = this.props.page;
        if (page !== 'list')
            return null;
            

        var user            = this.props.user;
        var guestList       = this.props.guestList;

        var selected        = this.state.selected;

        var rooms           = this.props.rooms || [];
        var selectedRoom    = this.props.selectedRoom;
        var selectedRoomArr    = this.props.selectedRoomArr;

        var filter          = this.state.filter.toLowerCase();

        var sortBy          = this.state.sortBy;
        var sortType        = this.state.sortType;

        var selectedRegister = this.props.selectedRegister;

        var smartCheckin = selectedLocation.UseSmartCheckin;
        
        

        var filteredList = guestList
            .filter(x => {
                if (filter.length < 1)
                    return x;
                else
                    return (
                        x.FullName.toLowerCase().indexOf(filter) !== -1 ||
                        x.nickname.toLowerCase().indexOf(filter) !== -1 ||
                        x.MJStateIDNo.toLowerCase().indexOf(filter) !== -1 ||
                        (x.TransactionReference || '').toLowerCase().indexOf(filter) !== -1
                    );
            })
            .filter(x => {
                if (this.state.showGuestAssignedToRegister)
                    return x;
                else
                    return x.Register.length === 0;
            });

        var sorter = sortBy;


        if (sortBy === 'CheckInDate') {
            filteredList.sort((a, b) => moment(a.CheckInDateUTC) - moment(b.CheckInDateUTC))
        } else {
            filteredList = _.orderBy(filteredList, sorter);
        }

        if (sortType === 'desc')
            filteredList = _.reverse(filteredList);

        var cssPrefix = !(selectedLocation.POSStatus && selectedLocation.POSShowRooms) ? 'guest-list__filter-single' : 'guest-list__filter-double';

        return (
            <div
                className={[
                    'guest-list__content',
                    (GuestListStore.getState().showSearchBar ? '' : 'guest-list__content--full-screen')
                ].join(' ')}>
                <div className='guest-list__header'>

                    <div
                        className='guest-list__header--icon'
                        onClick={() => { GuestListActions.loadGuestList(true); }}>

                        <i className='fa fa-sync-alt' aria-hidden='true' />
                    </div>

                    <div
                        className='guest-list__header--icon'
                        onClick={this.sort.bind(this, 'FullName')}>

                        <i className={'fa fa-sort-alpha-'+(sortBy === 'FullName' && sortType === 'asc' ? 'down' : 'up')} aria-hidden='true' />
                    </div>

                    <div
                        className='guest-list__header--icon'
                        onClick={this.sort.bind(this, 'CheckInDate')}>

                        <i className='far fa-clock' aria-hidden='true' />
                    </div>

                    <div
                        className={cssPrefix}
                        style={(rooms.length <= 1 ? {'width' : '516px'} : {})}>
                        <input
                            type='text'
                            onChange={(e) => { this.setState({ filter : e.target.value}); }}
                            value={this.state.filter}
                            placeholder='Filter Guestlist' />

                        { filter.length > 0 &&
                            <div
                                className={cssPrefix + '--clear'}
                                onClick={() => { this.setState({ filter : '' }); }}>

                                <i
                                    className='fa fa-times'
                                    aria-hidden='true' />
                            </div>
                        }
                    </div>

                    {selectedLocation.POSShowRooms &&
                        <GLRoom
                            selectedRoomArr={selectedRoomArr}
                            rooms={rooms}
                            location={selectedLocation}
                            isOnlyFilter={!selectedLocation.POSStatus}
                            guestList={guestList}
                            statusList={this.props.statusList} />
                    }

                    {selectedLocation.POSStatus && 
                        <GLStatus
                            selectedRoomArr={selectedRoomArr}
                            rooms={rooms}
                            location={selectedLocation}
                            guestList={guestList}
                            statusList={this.props.statusList} />
                    }

                </div>

                { !selectedLocation &&
                    <div className='guest-list__notice'>
                        Select a location
                    </div>
                }

                {!smartCheckin &&
                    <div>
                    <p style={{paddingLeft:'25px'}}>
                        <small>
                            Guest list refreshes every {this.state.delay / 1000} seconds
                        </small>
                    </p>
                    </div>
                }
                {smartCheckin && !this.state.pusherConnected &&
                    <div>
                        <p style={{paddingLeft:'25px'}}>
                            <small>
                                Real-time guest list updates have been disconnected, please refresh the guest list to update.
                            </small>
                        </p>
                    </div>
                }
                
                { filteredList && filteredList.map((guest, i) => {

                    if (selectedRoomArr.length > 0
                        && selectedRoomArr.indexOf(guest.Room) === -1
                        && selectedRoomArr.indexOf(guest.TransactionStatus) === -1) {
                        return null;
                    }

                    return (
                        <Guest
                            guest={guest}
                            user = {user}
                            selected={selected}
                            selectedLocation={selectedLocation}
                            onClick={(guest) => { this.setState({ selected : guest }); }}
                            statusList={this.props.statusList}
                            key={guest.Guest_id+'-'+i} />
                    );

                })}
            </div>
        );
    }
}

export default GuestList;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/List.react.jsx